import type { TrialSignUp } from '../../hooks/useTrialSignUp'
import { AlreadyMemberNotice } from '../AlreadyMemberNotice'
import { SubmitPlan } from '../SubmitPlan'

interface TrialSubmitProps {
  trial: TrialSignUp
  isSendingCode: boolean
}

export const TrialSubmit = ({ trial, isSendingCode }: TrialSubmitProps) => (
  <div className="space-y-2.5">
    <SubmitPlan
      agreedToTerms={trial.form.data.terms as boolean}
      isMutating={isSendingCode}
      loadingText="Sending code..."
    >
      Start free trial
    </SubmitPlan>
    {trial.error && <p className="text-sm text-red-500">{trial.error}</p>}
    {trial.isAlreadyMember && <AlreadyMemberNotice />}
  </div>
)
